import { Document, DocumentType } from '../types';

/**
 * Filters documents to match the logic used in the Financial Overview table.
 * 
 * Rules:
 * 1. Must have AI analysis.
 * 2. If 'documentTypes' is provided, the document's type must have 'aiOcrEnabled' (or be unspecified).
 * 3. Excludes 'invoice' / 'τιμολόγιο' types (Sales).
 * 4. Includes only documents relevant for Debts/Payments (e.g. EFKA, Tax, Bills).
 */
export const isFinancialDocument = (doc: Document, documentTypes: DocumentType[] = []): boolean => {
    // 1. Only show documents with AI analysis
    if (!doc.ai_analysis) return false;

    // 2. AI OCR Enabled check
    if (documentTypes && documentTypes.length > 0) {
        const typeConfig = documentTypes.find(t => t.id === doc.typeId);
        // If type found and AI OCR is explicitly disabled, HIDE IT.
        if (typeConfig && typeConfig.aiOcrEnabled === false) {
            return false;
        }
    }

    // 3. Custom Exclusion: Hide Invoices / Τιμολόγια (Sales)
    const typeLower = (doc.typeName || '').toLowerCase();
    if (typeLower.includes('invoice') || typeLower.includes('τιμολογ')) {
        return false;
    }

    return true;
};

export const getFinancialDocuments = (documents: Document[], documentTypes: DocumentType[] = []): Document[] => {
    if (!documents || documents.length === 0) return [];
    return documents.filter(doc => isFinancialDocument(doc, documentTypes));
};
